var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import store from '../../store';
import updateRecordsInLocalState from './updateRecordsInLocalState';
import cleanUpRecordsForRpcConsumption from './utils/cleanUpRecordsForRpcConsumption';
import getColumns from './columns/getColumns';
import getter from './getter';
import getRecordsByIds from './getRecordsByIds';
import arrayHasMembers from '../arrayOperations/arrayHasMembers';
import Notify from 'quasar/src/plugins/Notify.js';;
import left from '../stringOperations/left';
import arrayIsEmpty from '../arrayOperations/arrayIsEmpty';
import debuggerWhenDebugging from '../developer/debuggerWhenDebugging';
export default function updateRecords(entity, records) {
    return __awaiter(this, void 0, void 0, function* () {
        let records2 = [...records];
        if (records2.some(r => !r.id)) {
            const message = `<p>Some records to update in <span class="monospace">updateRecords</span> function have no <span class="monospace">id</span> field. <ul><li>Entity: ${entity}.</li><li>Records-in: ${left(JSON.stringify(records), 999)}.</li><li>Records-out: ${left(JSON.stringify(records2), 999)}</li></ul></p>`;
            return { result: 'error', messages: [{ message }] };
        }
        const applyToRecordBeforeUpdate = getter(entity, 'applyToRecordBeforeUpdate');
        if (typeof applyToRecordBeforeUpdate === 'function') {
            const currentStateOfRecords = yield getRecordsByIds(entity, records2.map(r => r.id));
            if (arrayIsEmpty(currentStateOfRecords))
                debuggerWhenDebugging();
            const newOldTupleArray = currentStateOfRecords.map((oldRecord, index) => {
                const newRecord = Object.assign(Object.assign({}, oldRecord), records2[index]);
                if (!newRecord)
                    debuggerWhenDebugging();
                return [newRecord, oldRecord];
            });
            records2 = newOldTupleArray.map(([newRecord, oldRecord]) => applyToRecordBeforeUpdate(newRecord, oldRecord));
            if (arrayIsEmpty(records2))
                debuggerWhenDebugging();
        }
        // Preemptively updating in local state. But the result of the remote call /update will overrite this. that's the intent. why: we're just speeding up UI interaction
        updateRecordsInLocalState(entity, records2);
        const cols = getColumns(entity);
        if (!arrayHasMembers(records2)) {
            const message = `<p>No records to update in <span class="monospace">updateRecords</span> function. <ul><li>Entity: ${entity}.</li><li>Records-in: ${left(JSON.stringify(records), 999)}.</li><li>Records-out: ${left(JSON.stringify(records2), 999)}</li></ul></p>`;
            Notify.create({ message, color: 'warning', html: true, closeBtn: '⨉', timeout: 0 });
            return { result: 'error', messages: [{ message }] };
        }
        else {
            const updateParams = { payload: { records: cleanUpRecordsForRpcConsumption(cols, records2) }, whoInitiatedThis: 'updateRecords' };
            return store.dispatch(entity + '/update', updateParams);
        }
    });
}
